import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetLicenceTransfersStatusesAsync,
  ILicenceTransfersGridFilterValueList,
} from "../../api/ILicenceTransfer";
import { RootState } from "../store";

export interface ILicenceTransfersGridState {
  fetchStatus: string;
  licenceTransferStatuses?: ILicenceTransfersGridFilterValueList;
}

const initialState: ILicenceTransfersGridState = {
  fetchStatus: "Loading...",
  licenceTransferStatuses: undefined,
};

export const loadLicenceTransfersOptionsAsync = createAsyncThunk(
  "licenceTransfers/loadOptions",
  async () => {
    const statuses = await GetLicenceTransfersStatusesAsync();
    // The value we return becomes the `fulfilled` action payload
    return {
      statuses: statuses,
    };
  }
);

export const licenceTransfersOptionsSlice = createSlice({
  name: "licenceTransfersOptions",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(loadLicenceTransfersOptionsAsync.pending, (state) => {
        state.fetchStatus = "loading";
      })
      .addCase(loadLicenceTransfersOptionsAsync.fulfilled, (state, action) => {
        state.fetchStatus = "idle";
        state.licenceTransferStatuses = action.payload.statuses;
      });
  },
});

export const selectLicenceTransfersOptions = (state: RootState) =>
  state.licenceTransfersOptions;

export default licenceTransfersOptionsSlice.reducer;
